module.exports = __webpack_public_path__ + "static/media/ecs3.02c555ba.png";